export const RESTRICTED_FILES = ["/index.html", "/package.json"];
